import React from "react";
import styles from "./contact.module.scss";

const Contact = () => {
  return (
    <div className={styles.contactContainer}>
    <h2 style={{textAlign:'center'}}>Contact Us</h2>
    <ul>
        <li>
            <i className="fas fa-phone"></i>
            <a href="tel:+91 7717302292">7717302292</a>
        </li>
        <li>
            <i className="fas fa-envelope"></i>
            <a href="mailto:Radiancehomespatiala24@gmail.com">Radiancehomespatiala24@gmail.com</a>
        </li>
        <li>
            <i className="fas fa-map-marker-alt"></i>
            <a href="https://www.google.com/maps?q=Radiance+homes,+Urban+estate+Phase-2,+Patiala+(147001)+Punjab" target="_blank" rel="noopener noreferrer">Radiance homes, Urban estate Phase-2, Patiala (147001), Punjab
            </a>
        </li>
    </ul>
</div>
  );
};
export default Contact;
